import React, { ReactNode, useMemo, useState } from 'react'
import AlternatePayeeForm from '../../components/AlternatePayee/AlternatePayeeForm';
import AddNewPayeeButton from '../../components/AlternatePayee/AddNewPayeeButton';
import SummaryPage from '../../components/AlternatePayee/SummaryPage';
import { useAPIManager } from '@cjdev-internal/visual-stack-x/hooks';
import { createRestApi, ENVS } from '../../components/AlternatePayee/Utils'
import { useAlternatePayeeManager } from '../../components/AlternatePayee/hooks/useAlternatePayeeManager';
import PageLayout from '../../components/PageLayout';
import { User, useUser } from '@platform/cj-platform-navigation'
import Unauthorized from '../../components/403'
import cjAuth from '../../auth/cjAuth'
import { alternatePayeeApi } from '../../components/AlternatePayee/services/alternatePayeeApi'
import { alternatePayeeResponseParser } from '../../components/AlternatePayee/services/alternatePayeeResponseParser'
import { AlternatePayeeApiConfig, AlternatePayeeServices } from '../../types'

const AlternatePayeeContainer = () => {
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  const apiMan = useAPIManager({});
  const user: User = useUser();

  const services = { api: alternatePayeeApi, responseParser: alternatePayeeResponseParser } as AlternatePayeeServices
  const showForbiddenErrorPage = (isForbiddenStatus: boolean) => {
    if (isForbiddenStatus) setIsUnauthorized(true);
  };
  const restApi = useMemo(() => createRestApi(apiMan, ENVS), [apiMan]);

  // API configuration for HTTP service
  const getBearerToken = () => cjAuth.getBearerToken()
  const { baseUrl, path } = restApi;
  const apiConfig: AlternatePayeeApiConfig = {
    baseUrl,
    path,
    getBearerToken
  };

  const alternatePayeeManagerProps = {
    restApi,
    user,
    showForbiddenErrorPage,
    apiConfig,
    services
  }

  const manager = useAlternatePayeeManager(alternatePayeeManagerProps);

  const DefaultTool = ({children}:{ children: ReactNode} ) => (
    <PageLayout
      toast={apiMan.toastMount}
      header="Alternate Payees"
      className="fintech-tool-page"
    >
      {children}
    </PageLayout>
  )

  if (isUnauthorized) {
    return <Unauthorized/>
  }

  if (manager.viewMode.isPayeeForm && manager.formStrategy) {
    return (
      <DefaultTool>
        <AlternatePayeeForm
          formStrategy={manager.formStrategy}
          fetchingStrategy={manager.fetchingStrategy}
          defaultValues={manager.selectedDefaultValues}
          bankCountryOptions={manager.bankCountryOptions}
          paymentCurrencyOptions={manager.paymentCurrencyOptions}
          accountTypeOptions={manager.accountTypeOptions}
          intl={manager.translations}
          handleSubmit={manager.handleSubmit}
          validator={manager.validator}
        />
      </DefaultTool>
    );
  }


  return (
    <DefaultTool>
      <SummaryPage
        handleView={manager.handleView}
        data={manager.alternatePayeeData}
        isFetching={manager.fetchingStrategy.isFetching}
        intl={manager.translations}
      />
      {!manager.fetchingStrategy.isFetching && (
        <AddNewPayeeButton
          showPayeeForm={manager.showPayeeForm}
          intl={manager.translations}
        />
      )}
    </DefaultTool>
  );
};

export default AlternatePayeeContainer;